import type { DrawerProps } from "antd";

export type DrawerSizeToken = "small" | "middle" | "large";
export type DrawerSize = DrawerSizeToken | number | "default" | "large";

const DRAWER_SIZE_MAP: Record<DrawerSizeToken, number> = {
  small: 480,
  middle: 640,
  large: 720,
};

export const resolveDrawerSize = (size?: DrawerSize): DrawerProps["size"] => {
  if (size === undefined) {
    return undefined;
  }
  if (typeof size === "string" && size in DRAWER_SIZE_MAP) {
    return DRAWER_SIZE_MAP[size as DrawerSizeToken];
  }
  if (size === "default" || size === "large" || typeof size === "number") {
    return size;
  }
  return undefined;
};
